module.exports = __webpack_public_path__ + "img/d2sj-btn.e20459e0.png";